import {TabContext, TabList} from '@mui/lab';
import {Stack, Tab} from '@mui/material';
import React, {FC} from 'react';
import {useStore} from 'zustand';
import {DashboardTypes} from '../../../../../../shared/types/dashboard.types';
import {useStoresContext} from '../../hooks/useStoresContext';
import {useDashboardTabsStore} from '../../store/useDashboardTabsStore';
import {DashboardArchiveCheckbox} from '../DashboardArchiveCheckbox';
import {DashboardPanel} from '../DashboardPanel';
import {STYLES} from './styles';

export const Dashboard: FC = () => {
  const {tabs, activeTab, setActiveTab} = useDashboardTabsStore();
  const {dashboardTypeStore} = useStoresContext(activeTab);
  const {dashboardType} = useStore(dashboardTypeStore);

  const handleTabChange = (_: React.SyntheticEvent, newValue: 'CHARGING_STATION' | 'ELECTRICITY_METER') => {
    setActiveTab(newValue);
  };

  return (
    <TabContext value={activeTab}>
      <Stack sx={STYLES.root}>
        <Stack sx={STYLES.header} direction="row">
          <TabList onChange={handleTabChange} sx={STYLES.tabs}>
            {tabs.map((tab) => (
              <Tab key={tab.value} label={tab.label} value={tab.value} />
            ))}
          </TabList>
          {dashboardType === DashboardTypes.REQUESTS_MOVE && <DashboardArchiveCheckbox />}
        </Stack>

        {tabs.map((tab) => (
          <DashboardPanel key={tab.value} serviceType={tab.value} />
        ))}
      </Stack>
    </TabContext>
  );
};
